import React from "react";
import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";

const Modal = ({ width = "w-full sm:w-[90%]", heigth = "h-fit max-h-[90%]", onClose, title = "", children }) => {
    const divClassname = `w-full sm:${width} ${heigth} bg-white rounded-md p-4 overflow-auto z-50 border-2 border-slate-400 shadow-xl`;

    return (
        <AnimatePresence>
            <motion.div
                className="fixed bottom-0 left-0 h-full w-full flex justify-center items-center z-50 bg-white/30 backdrop-blur-md"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                    className={divClassname}
                    initial={{ scale: 0.8, opacity: 0, y: 100 }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    exit={{ scale: 0.8, opacity: 0, y: 100 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                >
                    <div className="flex flex-row justify-between items-end">
                        <h2> {title} </h2>
                        <IoClose className="cursor-pointer" onClick={onClose} />
                    </div>
                    <div className="w-full h-0.5 border-2 border-slate-600 my-2" />
                    {children}
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default Modal;